module.exports = __webpack_public_path__ + "media/application/images/process_steps/mobile_bookstack_03-1b42546b7ea641a78369733296a87025.png";